module.exports = {
  defaultTitle: 'Kristin',
  author: 'Kristin',
  url: 'https://stinisson.se',
  legalName: 'Kristin',
  defaultDescription: 'I’m Kristin and I’m a software tester!',
  socialLinks: {
    twitter: 'https://twitter.com/stinisson',
    github: 'https://github.com/stinisson',
    linkedin: 'https://www.linkedin.com/in/kristin-k-24b105201',
    mail: 'mailto:kristin.karlsson@protonmail.com',
  },
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
    twitter: '@stinisson',
  },
  address: {
    city: 'City',
    region: 'Region',
    country: 'Country',
    zipCode: 'ZipCode',
  },
  contact: {
    email: 'email',
    phone: 'phone number',
  },
  foundingDate: '2021',
};
